import React, { useEffect, useMemo, useState } from "react";
import { formatNumberToCurrency } from "@utils/formatNumber";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import LoaderItem from "../value/accordion/LoaderItem";
import DetailsAccordion from "./DetailsAccordion";
import DetailsGraph from "./DetailsGraph";
import MultipleAdvanceForm from "./MultipleAdvanceForm";

export const advancementCreateMutation = (input) => ({ operation: "create", ...input });

export const advancementRemoveMutation = (entry, wbs) => ({
  operation: "remove",
  wbs,
  ...(entry?.entryId ? { entryId: entry.entryId } : {}),
  from: entry?.from,
  to: entry?.to,
});

const NewDataHandler = ({ max, from, name, wbs }) => {
  const { updateAdvancement } = useProjectActions()
  const { activeProject } = useProjectContext()
  const [newData, setNewData] = useState({
    max: max,
    from: from,
    value: '',
    to: '',
    description: '',
  })
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState({
    code: 0,
    msg: ''
  })

  const formatCurrency = (value) => {
    const cleanedValue = value.replace(/\D/g, "");
    const numericValue = parseFloat(cleanedValue) / 100;
    if (numericValue > max) {
      return max.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
    return numericValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const handleInputChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, "");
    if (inputValue.length === 0) {
      setNewData(prev => ({ ...prev, value: "" }));
    } else {
      setNewData(prev => ({ ...prev, value: formatCurrency(inputValue) }));
    }
  };

  const handleSend = async () => {
    // if (!newData.value) return 0;
    const cleanedString = newData.value
      .replace(/[R$.\s]/g, "")
      .replace(",", ".");
    const numericValue = parseFloat(cleanedString);
    const { description, to, from } = newData
    setLoading(true)
    const res = await updateAdvancement(advancementCreateMutation({
      name,
      value: numericValue,
      description,
      to,
      from,
      wbs,
    }))
    setResponse(res)
    setLoading(false)
  }

  const handleToChange = (e) => {
    const { value } = e.target
    setNewData(prev => ({ ...prev, to: `${value.slice(5, 7)}/${value.slice(0, 4)}` }))
  }

  const handleDescChange = (e) => {
    setNewData(prev => ({ ...prev, description: e.target.value }))
  }

  const checkDisabled = () => {
    return (newData.value === '' || newData.to === '' || loading)
  }


  return <>
    <p>Mover valores do mês {from}:</p>
    <div className="advancement-form-container">
      <div>
        <p>Selecione o valor que deseja mover:</p>
        <input
          type="text"
          max={newData.max}
          value={newData.value}
          onChange={handleInputChange}
          placeholder={`Máx.: ${formatNumberToCurrency(newData.max)}`}
        />
      </div>
      <div>
        <p>Selecione o mês de destino:</p>
        <input type='month' onChange={handleToChange} />
      </div>
      <div>
        <p>Descrição do ajuste (Opcional): </p>
        <input type='text' onChange={handleDescChange} />
      </div>
    </div>
    <div className="flex direction-column justify-content-end">
      <button className={`button button-${checkDisabled() ? 'grey' : 'accent'} margin-bottom-16 margin-top-8`} disabled={checkDisabled()} onClick={handleSend}>Enviar</button>
      {response.code === 200 && <p style={{ textAlign: 'end' }}>Ajuste criado!</p>}
      {response.code === 500 && <p style={{ textAlign: 'end' }}>Erro, tente novamente</p>}
    </div>
  </>
}

const renderRow = (label, value) => {
  return <div className="data">
    <span className="accordion-label">{label}</span>
    <span className="value">{value}</span>
  </div>
}

const getLabel = (label) => {
  switch (label) {
    case 'unit':
      return 'Unidade'
    case 'cell':
      return 'Célula'
    case 'step':
      return 'Etapa'
    case 'substep':
      return 'Subetapa'
    case 'service':
      return 'Serviço'
    default:
      break;
  }
}

const AdvancementAccordion = ({ item, wbs, isOpen, toggleItem }) => {
  const { getAppropriation, getAdvancements, updateAdvancement, getWbsPath } = useProjectActions();
  const { activeProject } = useProjectContext()
  const [toggle, setToggle] = useState(false)
  const [items, setItems] = useState([])
  const [status, setStatus] = useState({
    finished: false,
    searched: false
  })
  const [groupedMonths, setGroupedMonths] = useState([])
  const [transferData, setTransferData] = useState({
    from: '',
    to: '',
    max: 0,
    amount: 0
  })
  const [advancements, setAdvancements] = useState([])
  const [simple, setSimple] = useState(true)

  const [details, setDetails] = useState({})

  const getPath = async () => {
    const id = activeProject.wbs_code_ids.filter(i => item.wbs_code_id.includes(i))[0]
    const wbs = item.wbs_code_id.replace(id, '')
    const res = await getWbsPath(wbs, id)
    setDetails(res.response)
  }

  useEffect(() => {
    if (isOpen) {
      getPath()
    }
  }, [isOpen])

  const getItems = async () => {
    if (isOpen) {
      toggleItem(item.wbs_code_id);
      setStatus({ finished: false, searched: false });
      return;
    }
    toggleItem(item.wbs_code_id);
    setStatus({ ...status, searched: true });
    const response = await getAppropriation(activeProject?.appropriation_level, item.wbs_code_id)
    const adv = await getAdvancements(activeProject.building_id, item.wbs_code_id)
    setAdvancements(Array.isArray(adv?.response) ? [...adv.response] : []);
    setItems(Array.isArray(response?.items) ? [...response.items] : []);
    setStatus(prev => { return { ...prev, finished: true } })
    let months = [];
    if (Array.isArray(response?.items)) {
      response.items.forEach(i => {
        i.disbursements.forEach(j => {
          const idx = months.findIndex(k => k.year === j.year && k.month === j.month);
          if (idx === -1) {
            months.push({ ...j });
          } else {
            months[idx].value += j.value;
          }
        });
      });
    }
    months.sort((a, b) => {
      if (a.year !== b.year) {
        return a.year - b.year;
      } else {
        return a.month - b.month;
      }
    });
    setGroupedMonths(months)
  }


  const handleSelectMonth = (event, itemsClicked) => {
    if (!event.chart.tooltip.dataPoints) return
    if (itemsClicked) {
      const { label, raw: maxValue } = event.chart.tooltip.dataPoints[0]
      setTransferData(prev => { return { ...prev, from: label, max: maxValue } })
    }
  }

  const memoizedGraph = useMemo(() => (
    <DetailsGraph data={groupedMonths} onClick={handleSelectMonth} />
  ), [groupedMonths]);

  const handleDelete = async (entry) => {
    const response = await updateAdvancement(advancementRemoveMutation(entry, item.wbs_code_id))
    if (response?.code === 200) {
      const refreshed = await getAdvancements(activeProject.building_id, item.wbs_code_id)
      setAdvancements(Array.isArray(refreshed?.response) ? [...refreshed.response] : [])
    }
  };


  const Item = ({ item }) => {
    return <div key={item.creditor_name} id={item.wbs_code_id} className="accordion-item">
      <div className="accordion-item-body column-span-1" style={{ gridTemplateColumns: '1fr' }}>
        <div>
          <div className="flex align-center gap-8">
            <button
              className={`accordion-toggle ${isOpen ? "active" : ""}`}
              onClick={getItems}
            ></button>
            <div className="grid">
              <span className="accordion-title">{item.wbs_description}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="margin-left-16 advancement-infos-container">
        {isOpen && <div style={{ gridTemplateColumns: `repeat(${Object.entries(details).length}, 1fr)` }} className="accordion-item-body margin-bottom-8">
          {details.unit && Object.entries(details).map(([label, value]) => {
            return renderRow(getLabel(label), value)
          })}
        </div>}
        {(isOpen && status?.searched && status?.finished && items?.length === 0) && <p>Sem meses com desembolso para ajustar</p>}
        {(isOpen && items?.length === 0 && status?.searched && !status.finished) && <LoaderItem />}
        {Array.isArray(advancements[0]?.data) && advancements[0].data.length > 0 && advancements[0].data.map((i) => {
          return <div key={i.entryId || `${i.from}-${i.to}-${i.value}-${i.updated_at || ''}`} className="existing-advancements">
            <div>
              <p className="label">Valor:</p>
              <p className="value">{formatNumberToCurrency(i.value)}</p>
            </div>
            <div>
              <p className="label">Do mês:</p>
              <p className="value">{i.from}</p>
            </div>
            <div>
              <p className="label">Para o mês:</p>
              <p className="value">{i.to}</p>
            </div>
            <button style={{ alignSelf: 'auto' }} onClick={() => handleDelete(i)}>Deletar</button>
          </div>
        })}
        {(isOpen && status?.searched && status?.finished) && <div className="advancement-type-container">
          <h2 className={simple && 'active'} onClick={() => setSimple(true)}>Ajuste simples</h2>
          <h2 className={!simple && 'active'} onClick={() => setSimple(false)}>Ajuste múltiplo</h2>
        </div>}
        {(isOpen && items.length > 0) && <div>
          <div style={{ height: '250px', maxWidth: '85vw' }}>
            {memoizedGraph}
          </div>
          {(simple && transferData.from !== '') && <NewDataHandler max={transferData.max} from={transferData.from} name={item.description} wbs={wbs} />}
          {(!simple && <MultipleAdvanceForm months={groupedMonths} item={item} />)}
          <h3>Distribuição por insumo/mês:</h3>
          <div className="advancement-items">
            {items?.map(i => {
              return <DetailsAccordion item={i} />
            })}
          </div>
        </div>}
      </div>
    </div>
  }

  return <Item item={item} />
}

export default AdvancementAccordion;
